var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apply-form-settings',{attrs:{"form-setting":_vm.applicationForm,"preloader":_vm.preloader,"view-button":false},on:{"update":_vm.updateSetting}})}
var staticRenderFns = []

export { render, staticRenderFns }